var map = {
	"./Artificial-Insemination/1.png": 3545,
	"./Artificial-Insemination/2.png": 8930,
	"./Artificial-Insemination/3.png": 3755,
	"./Artificial-Insemination/4.png": 9892,
	"./Diet/1.png": 926,
	"./Diet/2.png": 8757,
	"./Diet/3.png": 4111,
	"./Diet/4.png": 3891,
	"./Diet/5.png": 8330,
	"./Diet/6.png": 9409,
	"./Diet/7.png": 8280,
	"./Diet/8.png": 3087,
	"./Diet/9.png": 7894,
	"./Medical/1.png": 223,
	"./Medical/10.png": 2911,
	"./Medical/11.png": 7814,
	"./Medical/12.png": 1581,
	"./Medical/13.png": 452,
	"./Medical/14.png": 6091,
	"./Medical/15.png": 8786,
	"./Medical/16.png": 2793,
	"./Medical/17.png": 688,
	"./Medical/18.png": 4519,
	"./Medical/19.png": 878,
	"./Medical/2.png": 4948,
	"./Medical/20.png": 4446,
	"./Medical/21.png": 2759,
	"./Medical/22.png": 2700,
	"./Medical/23.png": 1797,
	"./Medical/24.png": 5290,
	"./Medical/3.png": 8189,
	"./Medical/4.png": 8210,
	"./Medical/5.png": 9755,
	"./Medical/6.png": 2192,
	"./Medical/7.png": 6393,
	"./Medical/8.png": 638,
	"./Medical/9.png": 2775,
	"./Others/1.png": 5921,
	"./Others/2.png": 6938,
	"./Others/3.png": 7699,
	"./Others/4.png": 4092,
	"./Others/5.png": 3986,
	"./Others/6.png": 2830,
	"./Others/7.png": 2823,
	"./Thermal/1.png": 8507,
	"./Thermal/2.png": 864,
	"./Thermal/3.png": 7113,
	"./Thermal/4.png": 4070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8179;